import { ExtraInfoValue } from './types';
import { extraInfoConfig } from './configuration';
import { ExtraInfoCodes } from 'app/components/access-panel/shared/types';

export const hasExtraInfoCodes = (extraInfoCodes: ExtraInfoCodes) =>
  !!extraInfoCodes && !extraInfoCodes.fetching && extraInfoCodes.values && extraInfoCodes.values.length > 0;

export const hasExtraInfoValues = (extraInfo: ExtraInfoValue[]) =>
  !!extraInfo && extraInfo.length > 0 && extraInfo.filter(i => extraInfoConfig[i.datatype]).length > 0;
